import { Link } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import { Phone, Mail, MapPin } from "lucide-react";
import { BrandLogo } from "@/components/Header";

const COL_PATHS = [
  ["/solar", "/solar-calculator", "/mining", "/media"],
  ["/investors", "/esg", "/gallery", "/careers"],
  ["/contact", "/access-portal", "/download", "/admin/login"],
];

export default function Footer() {
  const { t, content } = useApp();
  const info = content.contact_info || {};

  return (
    <footer className="relative bg-[#015E5C] border-t border-teal-800/60 mt-auto" data-testid="site-footer">
      <div className="oj-container py-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10">
        <div className="lg:col-span-2">
          <div className="mb-4">
          <BrandLogo className="h-12" />
        </div>
          <p className="text-sm text-white/90 leading-relaxed max-w-sm">
            {t.foot.desc}
          </p>
          <div className="mt-5 space-y-2 text-sm text-white/90">
            <div className="flex items-start gap-2"><MapPin className="w-4 h-4 text-amber-300 mt-0.5 shrink-0" /> {info.address}</div>
            <a href={`tel:${info.phone}`} className="flex items-center gap-2 hover:text-amber-300 transition-colors"><Phone className="w-4 h-4 text-amber-300" /> {info.phone}</a>
            <a href={`mailto:${info.email}`} className="flex items-center gap-2 hover:text-amber-300 transition-colors"><Mail className="w-4 h-4 text-amber-300" /> {info.email}</a>
          </div>
        </div>
        {t.foot.cols.map((title, ci) => (
          <div key={title}>
            <h4 className="text-sm font-extrabold tracking-wide text-amber-300 mb-4">{title}</h4>
            <ul className="space-y-2.5">
              {COL_PATHS[ci].map((path, li) => (
                <li key={path}><Link to={path} className="inline-block py-2 text-sm text-white/85 hover:text-amber-300 transition-colors">{t.foot.links[ci][li]}</Link></li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="border-t border-teal-800/60">
        <div className="oj-container py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-white/75">
          <div className="flex flex-wrap items-center gap-x-3 gap-y-1">
            <span className="font-mono text-amber-300">CIN: {info.cin}</span>
            <span className="hidden sm:inline">•</span>
            <span>{t.tagline}</span>
          </div>
          <div>© {new Date().getFullYear()} OOJJAS Corporate Private Limited. ISO 27001:2022 Certified.</div>
        </div>
      </div>
    </footer>
  );
}
